import actions from 'src/modules/auth/authActions';

const auth = (store) => {
  store.dispatch(actions.doInit());
};

export default auth;